export interface MarkdownRichTextAreaOptions {
    inPopoverMode: boolean;
}

export const defaultMarkdownRichTextAreaOptions: MarkdownRichTextAreaOptions = {
    inPopoverMode: false
};